<template>
  <li>
    <router-link :to="{ name: 'payments.show', params: { bookingId: payment.booking_id, paymentId: payment.id, action: 'process' } }">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
          <h3>{{ bookingPaymentType }}</h3>
        </div>
        <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
          <p v-if="bookingPaymentIsOverdue"><span class="label label-danger">Overdue</span></p>
          <p v-else-if="bookingPaymentIsUnpaid"><span class="label label-info">Unpaid</span></p>
        </div>
        <div class="col-xs-6 col-sm-5 col-md-5 col-lg-3">
          <p><i class="fa fa-calendar"></i> Due By: {{ payment.due_date | date($user.date_format_preference) }}</p>
        </div>
      </div>
      <span class="price">
        <span class="amount">{{ payment.total_inclusive | currency(payment.currency) }}</span>
      </span>
    </router-link>
  </li>
</template>

<script>
import { paymentHelpers } from 'mixins/bookings'

export default {
  mixins: [paymentHelpers],

  props: {
    payment: {
      required: true,
      type: Object
    }
  }
}
</script>
